export default { viewer: "viewer", influencer: "influencer" };
